<script>
    // Presence marker for the indicator signal grid. The existing VT-group
    // timeframe-tab visibility gate and VT calculations remain independent.

    import { Overlay } from '../../'

    export default {
        name: 'TimeframeTrend',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'Mano', version: '1.0.0',
                    desc: 'Shows completed-candle signals for chart indicators across timeframes. VT Target tab coloring and native VT logic remain independent.',
                    preset: {
                        name: 'Timeframe Trend',
                        side: 'onchart',
                        settings: {}
                    }
                }
            },
            use_for() { return ['TimeframeTrend'] },
            draw() {}
        }
    }
</script>
